import { Action } from '@ngrx/store';
import { RoleModel } from '../../../security/models/RoleModel';

export const ADD_ROLE_TO_USER_SUCCESS = '[Customer] User Add Role Success';

export class AddRoleToUserSuccessAction implements Action {
  readonly type = ADD_ROLE_TO_USER_SUCCESS;

  constructor(public payload: { userKey: string, role: RoleModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/AddRoleToUserSuccessAction.ts